import React, { useContext, useEffect } from 'react';
import { Heading2, Text, Alert, AlertButton } from 'localmed-core';

import TrackClick from '../TrackClick';
import { PanelRule } from '../../../legacyCore/LegacyPanel';
import { IAppointment } from '../../../types';
import { UniversalContext } from '../../../_universal';
import { buildProviderSchedulingUrl } from '../../utils/urls';

interface Props {
  appointment: IAppointment;
  justScheduledToWidget: boolean;
}

export default function JustScheduled({ appointment, justScheduledToWidget }: Props) {
  const { trackEvent } = useContext(UniversalContext);
  const { provider } = appointment;

  useEffect(() => {
    trackEvent({
      event: 'Appointment scheduled',
      properties: {
        ...appointment,
      },
    });
  }, []);

  return (
    <React.Fragment>
      <Alert tier="success">
        <Heading2 color="inherit" marginBottom="xxs">
          Your appointment has been scheduled!
        </Heading2>
        <Text marginBottom="sm">
          Have more appointments to schedule? Let’s get those taken care of.
        </Text>
        <TrackClick
          event="Clicked Schedule Another Appointment"
          eventProperties={{ component: 'AppointmentInstructions' }}
        >
          {(getTrackingProps) => (
            <AlertButton
              data-qa="appointment-detail__schedule-another"
              className="margin-right-sm"
              {...{
                [justScheduledToWidget ? 'to' : 'href']: buildProviderSchedulingUrl(provider.id, {
                  widget: justScheduledToWidget,
                }),
              }}
              {...getTrackingProps()}
            >
              Schedule Another Appointment
            </AlertButton>
          )}
        </TrackClick>
      </Alert>
      <PanelRule />
    </React.Fragment>
  );
}
